webpackJsonp([53],{

/***/ "Rkgq":
/***/ (function(module, exports, __webpack_require__) {

var SubscriptionTitle = (function () {
    function SubscriptionTitle() {
    }
    return SubscriptionTitle;
}());
angular.module('animatronApp.SubscriptionTitle', [])
    .component('subscriptionTitle', {
    bindings: {
        sbTitle: '<'
    },
    transclude: true,
    controller: SubscriptionTitle,
    templateUrl: __webpack_require__("idd2")
});


/***/ }),

/***/ "idd2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/subscription-title_d17c940d278a59fbca4b820bbf8f8073.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/53-c7c98a0cc108ea8b91f3.min.js